import { Component } from '@angular/core';
import { StatusPageService } from './services/status-page.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'summary-status-page';
}
